// Client store module - handles client area data (projects, documents, invoices)
export default {
  namespaced: true,

  state: {
    projects: [],
    documents: [],
    invoices: [],
    notifications: [],
    loading: false,
    error: null,
  },

  getters: {
    getAllProjects: (state) => state.projects,
    getProjectById: (state) => (id) => {
      return state.projects.find((project) => project.id === id)
    },
    getAllDocuments: (state) => state.documents,
    getDocumentsByType: (state) => (type) => {
      return state.documents.filter((doc) => doc.type === type)
    },
    getAllInvoices: (state) => state.invoices,
    getPendingInvoices: (state) => {
      return state.invoices.filter((invoice) => invoice.status === "pending")
    },
    getNotifications: (state) => state.notifications,
    isLoading: (state) => state.loading,
    getError: (state) => state.error,
  },

  mutations: {
    SET_PROJECTS(state, projects) {
      state.projects = projects
    },
    SET_DOCUMENTS(state, documents) {
      state.documents = documents
    },
    SET_INVOICES(state, invoices) {
      state.invoices = invoices
    },
    SET_NOTIFICATIONS(state, notifications) {
      state.notifications = notifications
    },
    ADD_NOTIFICATION(state, notification) {
      state.notifications.unshift(notification)
    },
    MARK_NOTIFICATION_READ(state, notificationId) {
      const notification = state.notifications.find((n) => n.id === notificationId)
      if (notification) {
        notification.read = true
      }
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
  },

  actions: {
    async fetchProjects({ commit }) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const response = await fetch("YOUR_PHP_API_URL/client/projects", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        const data = await response.json()

        if (data.success) {
          commit("SET_PROJECTS", data.projects)
        } else {
          commit("SET_ERROR", data.message || "Error al cargar proyectos")
        }
      } catch (error) {
        console.error("[v0] Error fetching projects:", error)
        commit("SET_ERROR", "Error de conexión al cargar proyectos")
      } finally {
        commit("SET_LOADING", false)
      }
    },

    async fetchDocuments({ commit }) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const response = await fetch("YOUR_PHP_API_URL/client/documents", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        const data = await response.json()

        if (data.success) {
          commit("SET_DOCUMENTS", data.documents)
        } else {
          commit("SET_ERROR", data.message || "Error al cargar documentos")
        }
      } catch (error) {
        console.error("[v0] Error fetching documents:", error)
        commit("SET_ERROR", "Error de conexión al cargar documentos")
      } finally {
        commit("SET_LOADING", false)
      }
    },

    async fetchInvoices({ commit }) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const response = await fetch("YOUR_PHP_API_URL/client/invoices", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        const data = await response.json()

        if (data.success) {
          commit("SET_INVOICES", data.invoices)
        } else {
          commit("SET_ERROR", data.message || "Error al cargar facturas")
        }
      } catch (error) {
        console.error("[v0] Error fetching invoices:", error)
        commit("SET_ERROR", "Error de conexión al cargar facturas")
      } finally {
        commit("SET_LOADING", false)
      }
    },

    async fetchNotifications({ commit }) {
      try {
        const response = await fetch("YOUR_PHP_API_URL/client/notifications", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        const data = await response.json()

        if (data.success) {
          commit("SET_NOTIFICATIONS", data.notifications)
        }
      } catch (error) {
        console.error("[v0] Error fetching notifications:", error)
      }
    },

    async markNotificationAsRead({ commit }, notificationId) {
      try {
        const response = await fetch(`YOUR_PHP_API_URL/client/notifications/${notificationId}/read`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        const data = await response.json()

        if (data.success) {
          commit("MARK_NOTIFICATION_READ", notificationId)
        }
      } catch (error) {
        console.error("[v0] Error marking notification as read:", error)
      }
    },
  },
}
